export const Translations_IT = {
	footer: {
		join: "Unisciti alla discussione. Nessuna app o accesso richiesto.",
		climate: "Una discussione positiva per il clima.",
		tree: "L'albero è stato piantato.",
		start: "Avvia discussioni video gratuitamente.",
	},
};
